
import React from "react";
import { PersonalProfile } from "./PersonalProfile";

export function Page() {
  return <PersonalProfile />;
}
